// extracted by mini-css-extract-plugin
export default {"failureContainer":"Failure_failureContainer__im0lB","failure":"Failure_failure__RetS9"};